export default "__VITE_ASSET__DMovRsgn__"